/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    removeOperator: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Remove Operator',
        defaultMessage: "Remove Operator"
    },
    removeOperatorDesc: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Operator from the list?',
    },
    ope1: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Operators',
        defaultMessage: 'Operators'
    },
    lisOfOpe2: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.List of Operators',
        defaultMessage: 'List of Operators'
    },
    ifUnrPleExp3: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.If unrelated, please explain',
        defaultMessage: 'If unrelated, please explain'
    },
    valDriSLic4: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Valid drivers license',
        defaultMessage: 'Valid drivers license'
    },
    yeaAsOwnOfSimSizAnd5: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Years as owner of similar size and larger type boats',
        defaultMessage: 'Years as owner of similar size and larger type boats'
    },
    yeaOpeSimSizAndLarTyp6: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Years operating similar size and larger type boats',
        defaultMessage: 'Years operating similar size and larger type boats'
    },
    lisOfPriBoaOwnOrOpe7: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.List of Prior Boats Owned or Operated',
        defaultMessage: 'List of Prior Boats Owned or Operated'
    },
    volBoaEduExcManBoaLic8: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Voluntary Boating Education (Excluding Mandatory Boating License)',
        defaultMessage: 'Voluntary Boating Education (Excluding Mandatory Boating License)'
    },
    canPowSquCerCps9: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Canadian Power Squadron Certified (CPS)',
        defaultMessage: 'Canadian Power Squadron Certified (CPS)'
    },
    memCruOrYacClu10: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Member - Cruising or Yacht Club',
        defaultMessage: 'Member - Cruising or Yacht Club'
    },
    firNamFie: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.First Name',
        defaultMessage: 'First Name'
    },
    lasNamFie: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Last Name',
        defaultMessage: 'Last Name'
    },
    datofBirFie: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    perUsuBetOpe: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.% usage between operators',
        defaultMessage: '% usage between operators'
    },
    licNumFie: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.License Number',
        defaultMessage: 'License Number'
    },
    operatorList: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Relationship to owner',
        defaultMessage: 'Relationship to owner'
    },
    eduCouAndAffiTitle: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Operators.Education, Courses and Affiliations',
        defaultMessage: 'Education, Courses and Affiliations'
    },
    autRec1: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Auto Record',
        defaultMessage: 'Auto Record'
    },
    cleAutRec2: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Clear auto record',
        defaultMessage: 'Clear auto record'
    },
    movTraVio3: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Moving Traffic Violations',
        defaultMessage: 'Moving Traffic Violations'
    },
    deleteOperator: {   
         id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Delete Operator',
        defaultMessage: 'Delete Operator {opeName}',
    },
    removedOperator: {   
         id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Removed Operator',
        defaultMessage: 'Removed Operator {opeName}',
    },
    operator: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.AutoRecord.Operator',
        defaultMessage: 'Operator {count}',
    }    
});